import React, { useState, useRef, useEffect } from 'react';
import FloorplanPopup from "../components/floorplan";
import { useHistory } from "react-router";
import "./spaceFloorplanPopup.css"
import moment from 'moment-timezone';
import {LoadPanel as LoadingPanel} from 'devextreme-react/load-panel';
import jsPDF from 'jspdf';
import domtoimage from 'dom-to-image';


export default function SpaceFloorplanPopup(props) {
    const history = useHistory();
    const downloadTargetRef = useRef();
    const [loading, setLoading] = useState(false);
    const [showReportBtn, setShowReportBtn] = useState(false);
    function closePopup(){
        if(props.location.state.toggleEditBool){
            history.push({
                pathname:  `/config/space`,
             })
        } else {
            history.push({
                pathname:  `/spaces`,
             })
        }
    }

    useEffect(() => {
        const checkAndSetValue = () => {
            if(props.location && props.location.state && props.location.state.title && (props.location.state.title.includes('Anchors -') || props.location.state.title.includes('Assets -'))){
                console.log('ABC 1', props.location.state.title)
                setShowReportBtn(true)
            }
        };
        // Call the function inside useEffect to ensure it runs after the initial render
        checkAndSetValue();
      }, []);



    const captureComponent = () => {
        setLoading(true)
        const elementToCapture = document.getElementById('full-page-content-floorplan');

        domtoimage.toPng(elementToCapture)
          .then((dataUrl) => {
            // Handle the captured image dataUrl as needed
            console.log(dataUrl);
            const pdf = new jsPDF();

            // Add the captured image as a page in the PDF
            pdf.addImage(dataUrl, 'PNG', 10, 10, 190, 120); // Adjust the position and size as needed

            // Save the PDF with a specified filename
            pdf.save(`${props.location.state.title}-${moment().format('YYYY-MM-DD-HH-mm-ss')}.pdf`);
            setLoading(false)
          })
          .catch((error) => {
            setLoading(false)
            console.error('Error capturing element:', error);
          });
      };


    if(props.location !== undefined){
        if(props.location.state !== undefined){
            const myMarkers = props.location.state.myMarkers
            const spaceId = props.location.state.spaceId
            const type = props.location.state.type
            const windowType = props.location.state.windowType
            const zoneEditControl = props.location.state.zoneEditControl
            return (
                <div className="spaceFloorplan" id="full-page-content-floorplan" ref={downloadTargetRef}>
                    <div className="spaceFloorplan-bounds">
                        <div className="spaceFloorplan-title">
                            {props.location.state.title}
                            <div className='uploadBtnAssetsReport upload3' style={{display: showReportBtn ? 'block' : 'none', right: "75px", top: "50px" }}>
                              <button id="generatePdfButton" alt="Download Report" title="Download Report" type="button" onClick={() => captureComponent()}>
                                <span className="theme-svg-icon" style={{ WebkitMaskImage: 'url(../icons/reports.svg)', maskImage: 'url(../icons/reports.svg)', width: '24px', height: '24px' }}></span>
                              </button>
                            </div>
                            <div className="spaceFloorplan-close">
                                <i className="dx-icon-close" onClick={closePopup}></i>
                            </div>
                        </div>
                        <div className="spaceFloorplan-leaflet" >
                            <FloorplanPopup className="spaceFloorplan-bounds"  spaceId={spaceId} myMarkers={myMarkers} type={type} windowType={windowType}
                            moveMarkers={props.location.state.moveMarkers} zoneEditControl={zoneEditControl}>
                            </FloorplanPopup>
                        </div>
                    </div>
                    <LoadingPanel
                      shadingColor="rgba(0,0,0,0.4)"
                      visible={loading}
                      showIndicator={true}
                      showPane={true}
                      shading={true}
                      hideOnOutsideClick={false}
                    />
                </div>

            )
        } else {
            history.push({
                pathname:  `/spaces`,
             })
        }
    } return (
        <></>
    )
}
